// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"649":"334baa4b","2647":"334baa4b","9680":"31d6cfe0"}[chunkId] + ".chunk.css";
};